import { render, staticRenderFns } from "./SupportInbox.vue?vue&type=template&id=066cafa1&scoped=true&lang=pug"
import script from "./SupportInbox.vue?vue&type=script&lang=js"
export * from "./SupportInbox.vue?vue&type=script&lang=js"
import style0 from "./SupportInbox.vue?vue&type=style&index=0&id=066cafa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066cafa1",
  null
  
)

export default component.exports